import styled from 'styled-components';

export const STopBar = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SWrapper = styled.div`
  height: 55px;

  display: flex;
  align-items: center;
`;

interface IPanelContainerProps {
  isTopBarUsable: boolean;
  isSysPrinDocTypeHidden: boolean;
}

export const SPanelContainer = styled.div<IPanelContainerProps>`
  width: 26%;
  min-width: 500px;
  max-width: 500px;
  height: 100%;
  display: ${({ isSysPrinDocTypeHidden }) => (isSysPrinDocTypeHidden ? 'none' : 'unset')};
  pointer-events: ${({ isTopBarUsable }) => (isTopBarUsable ? 'unset' : 'none')};
  filter: ${({ isTopBarUsable }) => (isTopBarUsable ? 'unset' : 'brightness(0.9)')};
`;

export const SSelectorContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  min-width: 0;
  align-items: center;
`;

interface ISelectorProps {
  valueType: 'customer' | 'docType';
  active?: boolean;
}

export const SSelectorDiv = styled.div<ISelectorProps>`
  flex: 1;
  min-width: 0;
  height: 100%;

  display: flex;
  align-items: center;
  z-index: 0;

  background-color: ${({ theme }) => theme.colors.tertiaryBackground};

  ${({ valueType }) => {
    if (valueType === 'customer') {
      return `
        border-top-left-radius: 27.5px;
        border-bottom-left-radius: 27.5px;`;
    } else if (valueType === 'docType') {
      return `
        margin-left: -1px;`;
    }
  }}

  ${({ valueType, active, theme }) => {
    if (valueType === 'customer' && active) {
      return `
    border-top-left-radius: 16px;
    border-bottom-left-radius: 0px;
    filter: brightness(1.025);
    box-shadow: 0 3px 15px rgb(0 0 0 / 0.2);
    background-color: ${theme.colors.tertiaryBackground};`;
    }
    if (active) {
      return `
    filter: brightness(1.025);
    box-shadow: 0 3px 15px rgb(0 0 0 / 0.2);
    background-color: ${theme.colors.tertiaryBackground};`;
    }
  }}
`;

export const SSelectorIcon = styled.i`
  margin-left: 20px;
  margin-right: 20px;

  font-size: 22px;
  color: ${({ theme }) => theme.colors.lightIcon};
`;

export const SContentWrapper = styled.div`
  flex: 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
`;

interface IContentProps {
  valueType: 'title' | 'value';
}

export const SContent = styled.div<IContentProps>`
  width: 90%;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.tertiaryText};

  ${({ valueType, theme }) => {
    if (valueType === 'title') {
      return `
        font-size: 10px;
        font-weight: 500;
        font-family: ${theme.fonts.medium};
        letter-spacing: 0.1px;

        color: ${theme.colors.tertiaryText};`;
    } else if (valueType === 'value') {
      return `
        font-size: 15px;

        color: ${theme.colors.primaryText};`;
    }
  }}
`;

export const SDivider = styled.div<IPanelContainerProps>`
  width: 1px;
  height: 30px;

  z-index: 1;
  background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  display: ${({ isSysPrinDocTypeHidden }) => (isSysPrinDocTypeHidden ? 'none' : 'unset')};
`;

export const SDropdownContainer = styled.div<IPanelContainerProps>`
  display: flex;
  justify-content: end;
  display: ${({ isTopBarUsable }) => (isTopBarUsable ? 'unset' : 'none')};
`;

export const SDropdownIcon = styled.i`
  font-size: 10px;
  margin-right: 15px;

  color: ${({ theme }) => theme.colors.primaryText};
`;

export const SSearchIcon = styled.div<IPanelContainerProps>`
  width: 3.5%;
  min-width: 50px;
  max-width: 65px;
  height: 55px;

  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -1px;

  border-top-right-radius: 27.5px;
  border-bottom-right-radius: 27.5px;
  font-size: 18px;
  background-color: ${({ theme }) => theme.colors.tertiaryBackground};
  color: ${({ theme }) => theme.colors.primaryText};
  border-radius: ${({ isSysPrinDocTypeHidden }) => (isSysPrinDocTypeHidden ? '27.5px' : '')};
`;

interface IInstanceInfoProps {
  backgroundColor: string;
}
export const SInstanceInfo = styled.div<IInstanceInfoProps>`
  padding: 7px 14px 7px 14px;
  border-radius: 5px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
